import { css } from "@emotion/css"

export const styles = {
  main: css`
    display: flex;
    flex-flow: wrap;
    flex-direction: column;

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    input[type="number"] {
      -moz-appearance: textfield;
    }
  `,
  code: css`
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    margin-bottom: var(--spacing-xxl-5);
  `,
  section: css`
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
  `,
  billingSection: css`
    width: 485px;
    margin-top: var(--spacing-xxl-6);
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
  `,
  addressWrapper: css`
    width: 485px;
    margin-right: 69px;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    text-transform: capitalize;
  `,
  addresses: css`
    display: flex;
    flex-wrap: wrap;
    margin-top: var(--spacing-xl);
    font-size: 14px;
    font-weight: 300;
    color: var(--black);
  `,
  addressLabel: css`
    font-size: 14px;
    font-weight: 300;
    margin-bottom: 18px;
  `,
  addressDetails: css`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  `,
  inputsWrapper: css`
    display: flex;
    flex-wrap: wrap;
    width: 150%;
  `,
  addressInput: css`
    margin-right: 13px;
  `,
  addressDetail: css`
    width: 235px;
  `,
  zip: css`
    width: 158px;
  `,
  address: css`
    margin-top: var(--spacing-xs);
    width: 485px;
  `,
  sectionTitle: css`
    font-size: 14px;
    font-weight: bold;
    text-transform: capitalize;
  `,
  titleInput: css`
    width: 134px;
  `,
  dropdownInput: css`
    display: grid;
    grid-gap: var(--spacing-m);
    grid-template-columns: 1fr 1fr;
  `,
  nameInput: css`
    width: 277px;
  `,
  mailInput: css`
    width: 485px;
  `,
  billingDetails: css`
    width: 480px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: var(--spacing-xl);
    font-size: 14px;
    font-weight: 300;
    color: var(--black);
  `,
  selectIcon: css`
    width: 18px;
    height: var(--spacing-xl);
  `,
  phoneInput: css`
    width: 290px;
  `,
  number: css`
    width: 195px;
  `,
  numberWrapper: css`
    width: 480px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  codeInput: css`
    width: 100px;
    margin-left: var(--spacing-m);
  `,
  addPhone: css`
    font-size: 13px;
    font-weight: normal;
    color: var(--primary-main);
    cursor: pointer;
    margin-top: var(--spacing-m);
  `,
  deleteIcon: css`
    width: 24px;
    height: 24px;
    cursor: pointer;
    color: var(--grey);
  `,
  iconButton: css`
    &.MuiIconButton-root {
      margin-left: var(--spacing-s);
      margin-top: var(--spacing-xs);
    }
  `,
}
